$(window).load(function () {

    $('.js-print').click(function(e){
        window.print();
        e.preventDefault();
    });

});